'use client';
import PropTypes from 'prop-types';
import React from 'react';

import withRef from '../../utils/withRef';
import DropMenu from '../DropMenu';
import IconButton from '../IconButton';

export const IconMenuButton = ({ forwardedRef: ref, maxItems = 10, ...rest }) => (
  <DropMenu MenuAnchor={IconButton} maxItems={maxItems} {...rest} ref={ref} />
);

IconMenuButton.propTypes = {
  /** ID of the menu. */
  id: PropTypes.string.isRequired,
  /** Maximum number of menu items shown in the menu. */
  maxItems: PropTypes.number,
  /** The menu items to display in the dropdown. */
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      /** If `true`, destructive action style will be applied. */
      destructiveAction: PropTypes.bool,
      /** If `true`, the item renders as a title. */
      isTitle: PropTypes.bool,
      /** A unique identifier for the menu item. */
      key: PropTypes.string,
      /** The label content. Interchangeable with `text`. */
      label: PropTypes.node,
      /** Callback fired when the component is clicked. */
      onClick: PropTypes.func,
      /** The label content. Interchangeable with `label`. */
      text: PropTypes.node,
    })
  ),
  /** Callback fired when the menu open state changes (`true` when opened, `false` when closed). Used by `Tooltip` to hide while the menu is open. */
  onOpenChange: PropTypes.func,
  /** If `true`, the menu is visible. */
  open: PropTypes.bool,
  /** Placement of the `Popper`. */
  placement: PropTypes.oneOf([
    'auto-end',
    'auto-start',
    'auto',
    'bottom-end',
    'bottom-start',
    'bottom',
    'left-end',
    'left-start',
    'left',
    'right-end',
    'right-start',
    'right',
    'top-end',
    'top-start',
    'top',
  ]),
  /** Props applied to the `PopperMenu` component. */
  PopperMenuProps: PropTypes.object,
  /** The size of the component. */
  size: PropTypes.oneOf(['extraSmall', 'small', 'medium']),
};

export default withRef()(IconMenuButton);
